export default {
  projectDesc: '简洁、易用、高定制化的菜单解决方案',
  demo: {
    basic: '基础参数',
    regular: '常规模式菜单',
    advanced: '高级模式菜单',
    customWidth: '自定义菜单宽度',
    caller: '自定义菜单触发对象',
    align: '菜单对齐方向',
    noTitle: '关闭标题栏',
    rightClick: '鼠标右键呼出菜单',
    move: '鼠标移动呼出菜单',
    embed: '嵌入式菜单',
    groupActive: '指定菜单首次显示时默认激活的分组下标',
    slot: '使用插槽自定义显示内容',
    regularHeader: '标题格式的菜单项',
    regularGroup: '常规菜单多分组模式',
    regularLevel: '常规模式多级菜单',
    advancedShowField: '使用函数格式化显示内容',
    advancedNoQuery: '关闭搜索栏',
    advancedNoScroll: '关闭滚动条',
    advancedInit: '指定默认选中的菜单项',
    advancedMultipleInit: '指定默认选中的多个菜单项',
    advancedGroup: '高级多分组多选模式菜单',
    format: '数据格式'
  },
  option: {
    value: '选中项目的 keyField 值，多个内容使用 “,” 隔开，例如："3,5,7"',
    data: '菜单数据源指定',
    keyField: '指定作为键值的字段',
    showField: '指定行显示内容的字段，也可以设置 function 自定义显示内容',
    type: '菜单模式',
    align: '菜单弹出时的对齐方向',
    embed: '菜单嵌入在页面中，不以弹出的形式展现',
    rightClick: '鼠标右键点击呼出菜单',
    selected: '指定初始化选中项目，设置的内容会与 "keyField" 字段进行匹配；多选模式若希望初始化选中多个项目则在多个值之间使用逗号隔开，例如 <code>1,2,3</code>',
    title: '标题栏显示的默认文本，设置为 <code>false</code> 以关闭标题栏',
    query: '高级菜单模式的搜索区域是否显示',
    maxSelected: '高级菜单多选模式下最多选择的项目个数',
    multiple: '高级菜单模式下允许选择多个项目',
    scroll: '高级菜单模式下限制内容列表高度，并显示滚动条',
    disabled: '禁用插件',
    width: '自定义菜单宽度',
    fullWidth: '菜单触发对象使用块布局',
    activeGroup: '指定菜单首次显示时默认激活的分组下标'
  },
  event: {
    values: '返回选中项目的原始行数据',
    show: '菜单弹出/显示时，触发事件',
    hide: '菜单关闭时，触发事件'
  },
  api: {
    desc: '使用插件的 API 前，需要指定插件的 <code>ref</code> 属性，并使用 <code>this.$refs.xxx</code> 进行调用 API 方法',
    clear: '清除所有已选中的项目'
  }
}
